<template>
  <div class="">
    <Button class="mt-sm-1 button-header" @click="modalIsOpen = true"
      >{{ $t('header.market.buyButton') }}
    </Button>
    <Modal @close="modalIsOpen = false" v-if="modalIsOpen">
      <p>Выбор брокера</p>
      <a
        v-for="broker of brokers"
        :key="broker.id"
        @click="modalIsOpen = false"
        class="modal-button"
        :href="broker.link"
        target="_blank"
        rel="nofollow noopener"
      >
        <img
          class="broker-img"
          :src="'/img/icons/brokers/' + broker.id + '.png'"
          :alt="broker.id"
        />
        <p>{{ broker.name }}</p>
      </a>
    </Modal>
  </div>
</template>

<script>
import Button from '@/components/Screener/Button'
import Modal from '@/components/modals/Template'

export default {
  data() {
    return {
      modalIsOpen: false,
    }
  },
  computed: {
    brokers() {
      return [
        { id: 'tinkoff', name: 'Тинькофф', link: this.brokerLink('tinkoff') },
        {
          id: 'form',
          name: 'Нет моего брокера',
          link: this.brokerLink('form'),
        },
      ]
    },
  },
  methods: {
    brokerLink(broker) {
      switch (broker) {
        case 'tinkoff':
          return (
            'https://www.tinkoff.ru/invest/stocks/' +
            this.$store.state.market.ticker
          )
        case 'form':
          return 'https://forms.gle/D9C7jDfJqfFNiFKy7'
        default:
          return ''
      }
    },
  },
  components: {
    Button,
    Modal,
  },
}
</script>

<style lang="scss">
.header-bottom {
  .single-items {
    &.text-right {
      .button-header {
        width: 87px;
        height: 24px;
        position: relative;
        right: -2px;
        line-height: 100%;
        font-size: 0.8rem;
        background: $primary-color2 !important;
        color: #fff !important;
        &:hover {
          background: #fff !important;
          color: $primary-color2 !important;
        }
      }
      .modal-template {
        width: 294px;
        position: relative;
        top: -114px;
        & > p {
          letter-spacing: 0.4px;
          text-align: left !important;
          font-weight: bold;
          font-size: 1rem;
          line-height: 1.5rem;
          color: $title-color;
        }
        .modal-button {
          height: 36px;
          width: calc(100% - 2px);
          background: #eaeaf5;
          border-radius: 4px;
          margin: 12px 0px;
          border: none;
          box-sizing: border-box;
          border: 1px solid #eaeaf5;
          text-align: left;
          display: flex;
          align-items: center;
          padding: 6px;
          &:hover {
            border: 1px solid #f9a400;
          }
          .broker-img {
            width: 24px;
            height: 24px;
            border-radius: 24px;
            margin-right: 8px;
            margin-left: 2px;
          }
          p {
            color: $title-color;
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
